import { render, staticRenderFns } from "./OnlineCollaboratorsList.vue?vue&type=template&id=a7586648&scoped=true&"
import script from "./OnlineCollaboratorsList.vue?vue&type=script&lang=js&"
export * from "./OnlineCollaboratorsList.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCollaboratorsList.vue?vue&type=style&index=0&id=a7586648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7586648",
  null
  
)

export default component.exports